// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gap[data-v-734d0b88]{gap:2.5rem}.is-flex-basis-two-thirds[data-v-734d0b88]{flex-basis:66.6%}.is-flex-basis-auto[data-v-734d0b88]{flex-basis:auto}.max-width[data-v-734d0b88]{max-width:calc(100% - 1px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
